import {
	autoUpdate,
	flip,
	FloatingPortal,
	offset,
	safePolygon,
	shift,
	useFloating,
	useHover,
	useInteractions,
} from "@floating-ui/react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { useState } from "react";

export function SkillChipView({ node }: NodeViewProps) {
	const id = node.attrs.id as string | null;
	const label = node.attrs.label as string | null;
	const description = node.attrs.description as string | null;

	const [open, setOpen] = useState(false);

	const { context, refs, floatingStyles } = useFloating({
		open,
		onOpenChange: setOpen,
		placement: "top",
		strategy: "fixed",
		middleware: [offset(8), flip({ padding: 8 }), shift({ padding: 8 })],
		whileElementsMounted: autoUpdate,
	});

	const hover = useHover(context, {
		enabled: !!description,
		delay: { open: 150, close: 80 },
		handleClose: safePolygon(),
	});

	const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

	const text = `/${id ?? label ?? ""}`;

	return (
		<NodeViewWrapper as="span" className="inline">
			<span
				ref={refs.setReference}
				className="inline-flex cursor-default items-center rounded-md bg-primary/10 px-1.5 py-0.5 text-sm font-medium text-primary"
				data-skill={id}
				{...getReferenceProps()}
			>
				{text}
			</span>
			{open && description && (
				<FloatingPortal>
					<div
						ref={refs.setFloating}
						style={floatingStyles}
						className="z-50 max-w-xs rounded-md border bg-popover px-3 py-2 text-xs leading-relaxed text-popover-foreground shadow-md"
						role="tooltip"
						{...getFloatingProps()}
					>
						{description}
					</div>
				</FloatingPortal>
			)}
		</NodeViewWrapper>
	);
}
